// Application Constants

export const APP_NAME = 'CAP Admin Panel';
export const APP_VERSION = '1.0.0';

// Auto-logout after this many ms of user inactivity (no mouse/keyboard/touch).
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info',
  EXPENSES_ACCESS_TOKEN: 'expenses_access_token',
  EXPENSES_REFRESH_TOKEN: 'expenses_refresh_token',
  // Cars team — their own login, kept in its own keys so a car-team session
  // and a superadmin session can be open side by side without evicting
  // each other.
  CARS_ACCESS_TOKEN: 'cars_access_token',
  CARS_REFRESH_TOKEN: 'cars_refresh_token',
  CARS_STAFF: 'cars_staff',
};

export const AUTH_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500,
};

export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  SUPERVISOR_LOGIN: '/supervisor/login',
  // The landing screen — what needs the admin right now. DASHBOARD is still
  // the charts page, shown in the menu as "Business Overview".
  TODAY: '/today',
  // The list behind Today's "New inquiries" count — who came in, what they
  // asked for, who priced it.
  TODAY_INQUIRIES: '/today/inquiries',
  DASHBOARD: '/dashboard',
  PRODUCTS: '/products',
  PRODUCT_DETAIL: '/products/:id',
  NOT_AVAILABLE: '/not-available',
  RETURNS: '/returns',
  PAYMENTS: '/payments',
  PLANNED_PAYMENTS: '/planned-payments',
  MONEY_INVESTMENTS: '/money-investments',
  MONEY_INVESTMENT_DETAIL: '/money-investments/:id',
  DISPATCH: '/dispatch',
  OSM: '/osm',
  TRADE_INS: '/trade-ins',
  OUTSIDE_PARTS: '/outside-parts',
  ORDERS: '/orders',
  CUSTOMER_ORDERS: '/orders/customer/:customerId',
  CUSTOMERS: '/customers',
  SUPERVISORS: '/supervisors',
  SUPERVISOR_ANALYTICS: '/supervisors/:id/analytics',
  SALESPERSONS: '/salespersons',
  SALESPERSON_ANALYTICS: '/salespersons/:id/analytics',
  ANALYTICS: '/analytics',
  SETTINGS: '/settings',
  TEMPLATES: '/templates',
  EXCHANGE_PARTS: '/exchange-parts',
  SALE_REMINDERS: '/supervisor-sale-notes',
  // WHATSAPP_SETTINGS: '/whatsapp-settings',
  EXPENSES: '/expenses',
  // Read-only expense analytics in the main superadmin panel
  EXPENSE_REPORT: '/expense-report',
  // Read-only audit: prices the admin corrected at the checkpoint + why
  PRICE_CHANGES: '/price-changes',
  DELETED_RECORDS: '/deleted-records',
  // ADMIN (operations) workspace — expensadmin login: dispatch, counter sales, expenses
  // OPS_HOME is where the ops admin lands: their day, and what is left of it.
  OPS_HOME: '/ops/today',
  OPS_DISPATCH: '/ops/dispatch',
  OPS_COUNTER: '/ops/counter-sales',
  OPS_PAYMENTS: '/ops/payments',
  // Cars — whole cars sold as cars. Kept apart from PRODUCTS (donor cars
  // bought to be cut up for parts); the two are different businesses.
  CARS: '/cars',
  CAR_DETAIL: '/cars/:id',
  CARS_STAFF: '/cars/team',
  // CARS TEAM workspace — their own login (phone + password), same idea as the
  // ops admin's /ops/* screens. Kept under /lot so it can never collide with
  // the superadmin's /cars/:id.
  CARS_WORK: '/lot',
};
